const appLogger = global.log.child({
    name: 'APP',
});

function formatMetaData({ user = {}, listingId = null, context = '' }) {
    return {
        userToken: user.userToken,
        email: user.email,
        listingId,
        context,
    };
}

// TODO: refactor to DRY up code
// ex: log(type=error);
function logError({
    message, user, listingId, context,
}) {
    const meta = formatMetaData({ user, listingId, context });

    appLogger.error(meta, message);
}

function logInfo({
    message, user, listingId, context,
}) {
    const meta = formatMetaData({ user, listingId, context });

    appLogger.info(meta, message);
}

export default {
    logger: appLogger,
    logError,
    logInfo,
};
